import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = { appUrl: String }

  connect() {
    this.handleClick = this.handleClick.bind(this)
    this.element.addEventListener("click", this.handleClick, true)
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick, true)
  }

  handleClick(event) {
    const link = event.target.closest("a[href]")
    if (!link) return
    if (this.isInsideAllowedContent(link)) return
    if (this.shouldForceWaitlist(link) || !this.isAllowed(link)) {
      event.preventDefault()
      event.stopPropagation()
      this.open()
      return
    }
  }

  shouldForceWaitlist(link) {
    const marked = link.closest("[data-open-waitlist-gate]")
    if (!marked) return false
    return marked.getAttribute("data-open-waitlist-gate") === "true"
  }

  isInsideAllowedContent(link) {
    return link.closest("[data-waitlist-gate-allow]") !== null
  }

  isAllowed(link) {
    const href = link.getAttribute("href")
    if (!href) return true

    if (/^(mailto:|tel:|javascript:)/i.test(href)) return true

    if (href.startsWith("#")) return true

    let url
    try {
      url = new URL(link.href, window.location.href)
    } catch {
      return true
    }

    if (this.isSamePageHash(url)) return true

    if (this.isHomePath(url)) return true

    if (this.isPricingPath(url.pathname)) return true

    if (this.isBlogPath(url.pathname)) return true

    if (this.isDashboardAppLink(link, url)) return true

    return false
  }

  isSamePageHash(url) {
    if (!url.hash) return false

    const current = new URL(window.location.href)
    return (
      url.origin === current.origin &&
      url.pathname === current.pathname &&
      url.search === current.search
    )
  }

  isHomePath(url) {
    const current = new URL(window.location.href)
    if (url.origin !== current.origin) return false

    const normalized = url.pathname.replace(/\/+$/, "") || "/"
    return normalized === "/"
  }

  isPricingPath(pathname) {
    const normalized = pathname.replace(/\/+$/, "") || "/"
    return normalized === "/pricing" || normalized.startsWith("/pricing/")
  }

  isBlogPath(pathname) {
    const normalized = pathname.replace(/\/+$/, "") || "/"
    return normalized === "/blog" || normalized.startsWith("/blog/")
  }

  isDashboardAppLink(link, url) {
    if (!this.hasAppUrlValue) return false

    let appUrl
    try {
      appUrl = new URL(this.appUrlValue)
    } catch {
      return false
    }

    if (url.origin !== appUrl.origin) return false

    return /dashboard/i.test(link.textContent.trim())
  }

  open() {
    if (!this.hasDialogTarget) return
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }
}
